import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './beforeEach'
import i18n from '@/i18n/i18n';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/' + i18n.locale + '/pcshow',
    },
    {
      path: '/zhCN/pcshow',
      redirect: '/pcshow',
      component: () => import('@/views/platform/platform.vue')
    },
    {
      path: '/pcshow',
      component: () => import('@/views/platform/platform.vue')
    },
    {
      path: '/en/pcshow',
      component: () => import('@/views/platform/platform.vue')
    },
    {
      path: '/pcshow/robot',
      component: () => import('@/views/robot-arm/index.vue')
    },
    {
      path: '/en/pcshow/robot',
      component: () => import('@/views/robot-arm/index.vue')
    },
    {
      path: '/pcshow/test',
      component: () => import('@/views/test/index.vue')
    }
  ]
})
router.beforeEach(beforeEach)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js